import Button from '@/presentation/components/elements/Button';
import Icon, { Icons } from '@/presentation/components/elements/Icon';

const ClaimRewardsSuccess = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="p-6 bg-gray-50 max-w-lg mx-auto">
      <h2 className="text-lg text-center mb-2 font-bold">{'Success'}</h2>
      <div className="p-4 flex justify-center items-center">
        <Icon name={Icons.CHECK} size={48} className="text-green-500" />
      </div>
      <p className="text-center mb-8">
        {'Your rewards have been added to your wallet.'}
      </p>
      <div className="mb-4 flex justify-center">
        <Button type="button" variant="primary" onClick={onClose}>
          {'Close'}
        </Button>
      </div>
    </div>
  );
};

export default ClaimRewardsSuccess;
